/**
 * Created by Abner Sui on 09/27/2019
 * -------------------------------------
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../../widgets/widgets.module';
import { PopupModule } from '@progress/kendo-angular-popup';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { TaskSettingWrapperComponent } from './task-setting-wrapper.component';
import { TemplateConfigurationModule } from '../../template-configuration/template-configuration.module';
import { TaskDefinitionModule } from '../task-definition/task-definition.module';
import { TaskPostActionModule } from '../task-post-action/task-post-action.module';

@NgModule({
    imports: [
        CommonModule,
        PopupModule,
        DropDownsModule,
        WidgetsModule,
        TemplateConfigurationModule,
        TaskDefinitionModule,
        TaskPostActionModule,
    ],
    declarations: [
        TaskSettingWrapperComponent,
    ],
    exports: [
        TaskSettingWrapperComponent,
    ],
    providers: []
})
export class TaskSettingWrapperModule { }
